module.exports = __webpack_public_path__ + "static/img/voc-img-03.31feb37.png";